import type { PhraseGroup, Phrase } from '@/models/phrases'
import type { MutationTree } from 'vuex'
import type { PhrasesState } from './state'

export enum PhrasesMutationTypes {
  SetGroups = 'SetGroups',
  SetPhrases = 'SetPhrases',
}

export const mutations: MutationTree<PhrasesState> = {
  [PhrasesMutationTypes.SetGroups](
    state,
    payload: PhraseGroup[],
  ) {
    state.groups = payload
  },
  [PhrasesMutationTypes.SetPhrases](
    state,
    payload: Record<string, Phrase[]>,
  ) {
    state.phrasesByGroup = payload
  },
}
